import { type RouteObject } from 'react-router';
import { standaloneLayout } from '@/app/layouts';
import { ROUTES } from '@/shared/routing';

/**
 * 앱 열기 폴백 — `/open/*`. 외부로 뿌리는 링크의 착지점으로, 앱 열기(커스텀 스킴)·설치(스토어)·
 * 웹 계속보기를 고르게 한다. 목적지는 `/open` 뒤 경로를 그대로 잇는다(`/open/alerts` → `/alerts`).
 *
 * public(비인증) — 링크를 받은 사람이 로그인 상태인지 알 수 없고, 앱 설치 유도에 세션이 필요하지도 않다.
 * (목적지 화면 자체의 인증은 그쪽 라우트가 알아서 건다.)
 *
 * **web 전용** — 앱 안에서 이 화면을 열 이유가 없다(이미 앱이다). 오히려 앱이 자기 스킴을 다시 여는
 * 루프가 될 수 있어 모바일 빌드에선 트리에서 제외한다(`/help`·subscription 과 같은 게이트).
 */
export function createOpenRoute(): RouteObject | null {
  if (import.meta.env.VITE_BUILD_TARGET !== 'web') return null;

  const page = { lazy: { Component: () => import('@/pages/open').then((m) => m.OpenPage) } };

  return {
    element: standaloneLayout({ width: 'sm' }),
    path: ROUTES.OPEN,
    children: [
      // `/open` 단독 진입(목적지 없음) — 화면이 대시보드로 접는다.
      { index: true, ...page },
      // `/open/<목적지>` — **splat 은 leaf 에 둔다**. 부모 path 를 `/open/*` 로 잡으면 `index` 자식이
      // 매칭되지 않아 화면이 통째로 비어 버린다(app-routes 글로벌 폴백과 같은 함정).
      { path: '*', ...page },
    ],
  };
}
